import { Injectable } from "@angular/core";
import { GeozoneViewModel } from "../system/admin-panel/Geozone/Model/GeozoneViewModel";
import { HttpClient } from "@angular/common/http";
import { ObjectGroupViewModel } from "../system/admin-panel/ObjectGroupViewModel";
import { IOwnerManipulationService, ShareObjectViewModel } from "./IOwnerManipulationService";
import { SyncService } from './sync.service';
import { map } from "rxjs/operators";
import { IconViewModel } from "../models/IconViewModel";
import { Observable } from "rxjs";

@Injectable()
export class ZoneService implements IOwnerManipulationService {


  constructor(private client: HttpClient, private syncService: SyncService) {

  }

  public GetUserObjects(userId: number) {
    return this.client.get<any>("/ctrl/Geozones/user/" + userId).pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(GeozoneViewModel.fromJS(item))
      }

      return result;
    }))
  }

  public SetObjects(zoneId: number, objectIds: number[]) {
    return this.client.post<any>("/ctrl/Geozones/objects/" + zoneId, objectIds);
  }

  public SetOwner(fromUserId: number, toUserId: number, objectIds: number[]) {
    let input = new ShareObjectViewModel(fromUserId, toUserId, objectIds);
    return this.client.post("/ctrl/Geozones/SetOwner", input).pipe(map(res => {
      this.syncService.NotifyEntityChanged("Profile", 0);
      return res;
    }));
  }

  public ShareObject(fromUserId: number, toUserId: number, objectIds: number[]) {
    let input = new ShareObjectViewModel(fromUserId, toUserId, objectIds);
    return this.client.post("/ctrl/Geozones/Share", input).pipe(map(res => {
      this.syncService.NotifyEntityChanged("Profile", 0);
      return res;
    }));
  }

  public StopSharing(fromUserId: number, toUserId: number, objectIds: number[]) {
    /*let input = new ShareObjectViewModel(fromUserId, toUserId, objectIds);
    return this.client.post("/ctrl/zones/StopSharing", input).pipe(map(res => {
      this.syncService.NotifyEntityChanged("Profile", 0);
      return res;
    }));*/
  }
  //////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////
  public GetGroups() {
    return this.client.get<any>("/ctrl/Geozones/Groups").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array)
        for (let item of values)
          result.push(ObjectGroupViewModel.fromJS(item))

      return result;
    }));
  }

  /*public GetZoneGroups(zoneId) {
    return this.client.get<any>("/ctrl/Geozones/GroupsList/" + zoneId).pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(ObjectGroupViewModel.fromJS(item))
      }

      return result;
    }))
  }*/

  public CreateGroup(input) {
    if (input.Id > 0)
      return this.client.put("/ctrl/Geozones/groups", input);
    else
      return this.client.post("/ctrl/Geozones/groups", input);
  }

  public DeleteGroup(input) {
    return this.client.delete("/ctrl/Geozones/Groups/" + input.Id);
  }
  //////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////
  public GetZones() {
    return this.client.get<any>("/ctrl/Geozones").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array)
        for (let item of values)
          result.push(GeozoneViewModel.fromJS(item))
      return result;
    }));
  }

  public GetZone(id: number): Observable<GeozoneViewModel> {
    return this.client
      .get<any>(`/ctrl/Geozones/${id}`)
      .pipe(
        map(value => GeozoneViewModel.fromJS(value))
      );
  }

  public DeleteZone(id) {
    return this.client.delete("/ctrl/Geozones/" + id);
  }
  public EditZone(model: GeozoneViewModel) {
    return this.client.put("/ctrl/Geozones", model);
  }

  public CreateZone(model: GeozoneViewModel) {
    return this.client.post("ctrl/Geozones", model);
  }
  //////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////
  public GetZoneIcons() {
    return this.client.get<any>("/ctrl/Geozones/icons").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array)
        for (let item of values)
          result.push(IconViewModel.fromJS(item))

      return result;
    }));
  }
  //////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////
  public Import(file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.client.post('/ctrl/Geozones/import', formData);
  }

  export(zoneIds: number[]) {
    return this.client.post("/ctrl/Geozones/export", zoneIds, { responseType: 'blob' });
  }
}
